module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAABX0lEQVQ4T6VTu0rEUBSc2bgRVxcVG7H0U0QRRFtBURAEbUTbELKQFQlro4i9CuKj8QNsRGz8AX9B2W4F3VUSco/ckISYTRo95XncMzNnLnuNxirC8BDA05BSO2y1OiiJjuuOmb5/DGC+Uqk02LXtVwBTup8iDyG5V/e8l/z8t2VNh4ZxCpGFqEa22bPtKwFWo4RISPJRmebaiOu2kwf0xkHfPxNgCcBAnL+jWNZ4l7wmMAfSiAv3NaVWNIUIahBcQmQxrikAz6hWl6kTfZBiCmIYJxDZTqHmqEXDOj5dd5K+f6HFSCiAfAcwmkDVmohprg83m28R7awwJRR0Swo1Gewbjig4zmyo1C2AieRhAh8hsFX3PJ1P49fmElVLr5AOF6lKoCsitaIrpLD/rHYR1KyqRVdIjKTteQ5gI2+ArKpFVyB58z9vfznOplJqP7bcbnZj/nNoCpUgOBKRGZIHPyi77p7gVBDMAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/close2.png
// module id = yh/K
// module chunks = 67